export default "__VITE_ASSET__DNqNr7k$__"